Librarian.ModuleLoader2 = new Class({
    Implements: [Options, Events],
    Binds: ["render", "renderRow", "renderCell", "renderModule"],

    options: {
        container: "homepage",
        title: null,
        width: null,
        maxWidth: null,
        moduleSpacing: null,
        modulePadding: null,
        moduleWidth: null,
        moduleHeight: null
    },

    className: "page-layout",
    containerEl: null,

    modules: {},

    eventHandler: null,

    initialize: function(options) {
        this.setOptions(options);

        if (!this.options.container)
            return;

        this.containerEl = $(this.options.container);
        this.eventHandler = new Events();
    },

    load: function(layout) {
        this.layout = layout;

        this.render();
    },

    render: function() {
        this.containerEl.empty();
        this.containerEl.removeClass("pure-g-r");

        this.createTable();

        var totalColumns = 0,
            self = this;

        this.layout.rows.forEach(function(row) {
            var colCount = self.renderRow(row);

            totalColumns = Math.max(totalColumns, colCount);
        });

        if (this.options.title)
            this.createHeader(totalColumns);

        this.createSpacingRow(totalColumns);

        this.eventHandler.fireEvent("pageRendered");
    },

    createTable: function() {
        this.tableEl = new Element("table", {
            "class": this.className + "-table"
        }).injectInside(this.containerEl);

        this.tableEl.setStyles({
            "width": this.getSizeValue(this.options.width),
            "maxWidth": this.getSizeValue(this.options.maxWidth)
        });

        if (this.options.moduleSpacing) {
            this.tableEl.setStyle("border-collapse", "separate");
            this.tableEl.setStyle("border-spacing", this.getSizeValue(this.options.moduleSpacing));
        }
    },

    createHeader: function(totalColumns) {
        var headerRow = new Element("tr", {
            "class": this.className + "-header-row"
        }).injectTop(this.tableEl);

        var header = new Element("td", {
            "class": this.className + "-header",
            "colspan": totalColumns,
            styles: {
                "padding": this.getSizeValue(this.options.modulePadding)
            }
        }).injectInside(headerRow);

        var title = new Element("div", {
            "class": this.className + "-title",
            "text": this.options.title
        }).injectInside(header);
    },

    createSpacingRow: function(totalColumns) {
        var spacingRow = new Element("tr", {
            "class": this.className + "-spacing-row"
        }).injectInside(this.tableEl);

        for (var i = 0; i < totalColumns; i++) {
            var td = new Element("td", {
                "class": this.className + "-cell"
            }).injectInside(spacingRow);

            if (this.options.moduleWidth) {
                var width = this.getSizeValue(this.options.moduleWidth);
                td.setStyle("width", width);
                td.setStyle("min-width", width);
                td.setStyle("max-width", width);
            }
        }
    },

    renderRow: function(row) {
        var tr = this.createTr(row),
            colCount = 0,
            self = this;

        row.modules.forEach(function(module) {
            colCount += parseInt(module.colSpan) || 1;

            self.renderCell(module, tr);
        });

        return colCount;
    },

    createTr: function(row) {
        var tr = new Element("tr", {
            "class": this.className + "-row"
        }).injectInside(this.tableEl);

        var height = row.height || this.options.moduleHeight;
        if (height)
            tr.setStyle("height", this.getSizeValue(height));

        if (row.style) {
            var styles = this.parseStyles(row.style);

            tr.setStyles(styles);
        }

        return tr;
    },

    renderCell: function(module, tr) {
        var td = this.createTd(module, tr);

        this.renderModule(module, td);
    },

    createTd: function(module, tr) {
        var colSpan = parseInt(module.colSpan) || 1,
            rowSpan = parseInt(module.rowSpan) || 1,
            td = new Element("td", {
                "class": this.className + "-cell",
                "colspan": colSpan,
                "rowspan": rowSpan
            }).injectInside(tr);

        if (this.options.modulePadding)
            td.setStyle("padding", this.getSizeValue(this.options.modulePadding));

        if (module.style) {
            var styles = this.parseStyles(module.style);

            td.setStyles(styles);
        }

        return td;
    },

    renderModule: function(moduleInfo, td) {
        var moduleWrapper = new Element("div", {
            styles: {
                height: "100%"
            }
        }).injectInside(td);

        if (moduleInfo.type == "skip" || moduleInfo.type == "placeholder")
            return;

        var options = Object.merge({
            id: moduleInfo.id,
            eventHandler: this.eventHandler
        }, moduleInfo.options);

        if (moduleInfo.title)
            options.title = moduleInfo.title;

        var module = new Librarian.Modules[moduleInfo.type](options, moduleWrapper, false);

        module.moduleInfo = moduleInfo;
        module.load();
    },

    getSizeValue: function(value) {
        if (!value)
            return null;

        value = value.toString();

        if (value.contains('%'))
            return value;

        if (!value.contains('px'))
            value += 'px';

        return value;
    },

    parseStyles: function(styleString) {
        var styles = {};

        var nameValuePairs = styleString.split(';');
        nameValuePairs.forEach(function(pair) {
            var parts = pair.split(":");

            var name = parts[0],
                value = parts[1];

            if (name && value)
                styles[name.trim()] = value.trim();
        });

        return styles;
    }

});